/**
 * Structural subset of @astrana/ui's `PatientPriorityIndexSelectedMember`
 * this helper needs. Declared locally (rather than importing the type from
 * `@astrana/ui/modules`) so this file — and its unit test — don't depend on
 * that package's declaration files at typecheck time; WorklistPage.tsx's own
 * `member` param is still the real, fully-typed
 * `PatientPriorityIndexSelectedMember` and is structurally assignable here.
 */
export interface WorklistNavStateMember {
  companyId?: string;
  memberId?: string;
  membKeyId?: string;
  name?: string;
  dob?: string;
}

/**
 * Build the react-router `state` payload for a worklist row click. Pulled out
 * of WorklistPage.tsx's `handleSelectMember` so the nav-state shape is
 * unit-testable without mounting the page (which pulls in @astrana/ui's
 * PatientPriorityIndex module). See `handleSelectMember`'s doc comment in
 * WorklistPage.tsx for WHY name/dob/tabTitle are threaded through: the
 * Create-Auth PP crosswalk needs name+DOB (astrana:-only members skip the
 * Pathways query that would otherwise supply them), and the tab shell needs
 * `tabTitle` to title the newly-opened patient tab.
 */
export function buildWorklistMemberNavState(
  astranaId: string,
  member: WorklistNavStateMember,
): {
  astranaMember: {
    astranaId: string;
    companyId?: string;
    memberId?: string;
    membKeyId?: string;
    name?: string;
    dob?: string;
  };
  tabTitle?: string;
} {
  return {
    astranaMember: {
      astranaId,
      companyId: member.companyId || undefined,
      memberId: member.memberId || undefined,
      membKeyId: member.membKeyId || undefined,
      name: member.name || undefined,
      dob: member.dob || undefined,
    },
    ...(member.name ? { tabTitle: member.name } : {}),
  };
}
